import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {PercentageCircle} from '@/components/common/progress/PercentageCircle'
import {getBlogContent} from '@/content/blog/blog'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type MetricsListProps = {
  importance: number
  willingness: number
}

export const MetricsList: FC<React.PropsWithChildren<MetricsListProps>> = ({
  importance,
  willingness,
}) => {
  const {t} = useTranslation()
  const {importanceTitle, willingnessTitle} = getBlogContent().metrics

  return (
    <>
      <ul className="list">
        <li className="item">
          <PercentageCircle percentage={importance} />
          <div className="title">
            <Text variant={TextVariant.h4} mobileVariant={TextVariant.h6} element="p">
              {t(importanceTitle)}
            </Text>
          </div>
        </li>
        <li className="item">
          <PercentageCircle percentage={willingness} />
          <div className="title">
            <Text variant={TextVariant.h4} mobileVariant={TextVariant.h6} element="p">
              {t(willingnessTitle)}
            </Text>
          </div>
        </li>
      </ul>

      <style jsx>{`
        .list {
          display: flex;
          align-items: center;
          margin-top: ${theme.spacing[5]};
        }
        .item {
          display: flex;
          align-items: center;
          max-width: 420px;
        }
        .item + .item {
          margin-left: ${theme.spacing[9]};
        }
        .title {
          margin-left: ${theme.spacing[5]};
        }
        @media ${TABLET_SCREENSIZE} {
          .list {
            justify-content: center;
          }
          .item {
            display: block;
            max-width: 240px;
          }
          .title {
            margin-left: 0;
            margin-top: ${theme.spacing[3]};
            text-align: center;
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .list {
            flex-direction: column;
            margin-top: ${theme.spacing[5]};
          }
          .item {
            max-width: 200px;
          }
          .item + .item {
            margin-left: 0;
            margin-top: ${theme.spacing[5]};
          }
          .title {
            margin-top: ${theme.spacing[2]};
          }
        }
      `}</style>
    </>
  )
}
